export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '蓝色导航发布页是什么？',
    answer: '蓝色导航发布页是一个专业的内容发布与网站导航平台，为用户提供高效便捷的发布管理工具。您可以在这里快速完成内容上线、链接归类与流量导引，实现精准的内容触达。',
  },
  {
    question: '如何使用蓝色导航发布页的导航功能？',
    answer: '使用非常简单！您只需访问我们的首页，即可看到按类别整理好的导航链接。我们覆盖了资讯媒体、搜索引擎、社交平台、电商购物、学习教育、工具应用、影视音乐、生活服务等8大分类，只需点击对应分类即可浏览相关网站链接。',
  },
  {
    question: '蓝色导航发布页支持哪些内容类型？',
    answer: '我们支持多种内容类型的发布，包括：网站导航链接、行业资讯文章、运营指南教程、产品推广内容等。无论您是想分享有价值的网站资源，还是发布专业的行业内容，蓝色导航发布页都能满足您的需求。',
  },
  {
    question: '如何将我的网站提交到蓝色导航发布页？',
    answer: '目前您可以通过我们的"关于我们"页面的联系表单提交您的网站信息。我们的编辑团队会审核您提交的网站内容，确保质量和相关性后，将其添加到对应的导航分类中。审核周期通常为1-3个工作日。',
  },
  {
    question: '蓝色导航发布页的内容多久更新一次？',
    answer: '我们的编辑团队保持每日更新的频率。热门分类（如资讯媒体、电商购物）的内容更新会更加频繁。同时我们也会根据行业热点和用户反馈，及时调整和优化导航内容，确保信息的时效性和实用性。',
  },
  {
    question: '蓝色导航发布页是否收费？',
    answer: '蓝色导航发布页的基础导航和内容浏览功能完全免费。我们致力于为所有用户提供优质的导航和内容发布服务。未来我们可能会推出高级会员服务，提供更多定制化的发布和数据分析功能，但核心的导航浏览功能将始终保持免费。',
  },
  {
    question: '如何联系蓝色导航发布页的运营团队？',
    answer: '您可以通过"关于我们"页面的联系表单与我们取得联系。此外，您也可以发送邮件至我们的官方邮箱或在社交媒体平台上关注我们的官方账号。我们会在24小时内回复您的咨询。',
  },
];